import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import HistoryIcon from "@mui/icons-material/History";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import {
  Alert,
  Box,
  CircularProgress,
  Grid,
  Modal,
  Snackbar,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ButtonCustomized from "../../../../common/components/ButtonCustomized";
import PaperCustomized from "../../../../common/components/PaperCustomized";
import ScrollToTop from "../../../../common/components/ScrollToTop";
import StickyCustomized from "../../../../common/components/StickyCustomized";
import {
  CONSULTATION_TITRES_PAGE,
  GESTION_TITRES_PAGE,
  TITRE_HISTORIQUE_PAGE,
} from "../../../../common/constants/routerConstants";
import {
  formattedDateFromDB,
  formattedDateTimeFromDB,
} from "../../../../common/utils/FunctionsUtils";
import { clearTiErrors, downloadTi, getTi } from "../../state/TiActions";
import ListDocuments from "../ListDocuments";
import ListFactures from "../ListFactures";
import ListMarchandises from "../ListMarchandises";
import ListMarchandisesImputees from "../ListMarchandisesImputees";
import ListMarchandisesModified from "../ListMarchandisesModified";
import ListPaysProvenances from "../ListPaysProvenances";
import ListReglamentation from "../ListReglamentation";
import ListTracMinistere from "../ListTracMinistere";

export function BoldTypography({ label, value }) {
  return (
    <Typography>
      {label && (
        <Typography
          component="span"
          variant="inherit"
          sx={{ fontWeight: "bold" }}
        >
          {label} :{" "}
        </Typography>
      )}
      {value}
    </Typography>
  );
}

function TitreDetailConsult(props) {
  const { id } = useParams();
  const location = useLocation();
  const [isDecision, setIsDecision] = useState(
    location.state?.isDecision || false
  );

  const titreReducer = useSelector((state) => state.titreReducer);
  const [isModeConsultation, setModeConsultation] = useState(
    titreReducer?.consultingMode
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tiReducer = useSelector((state) => state.tiReducer);
  const tiDetail = tiReducer?.titreDetail;
  const tiDomiciliationBanque = tiDetail?.tiDomiciliationBanque;
  const isLoading = tiReducer?.isLoading;
  const loading = isLoading;
  const [openFacture, setOpenFacture] = useState(false);
  const [openDoc, setOpenDoc] = useState(false);
  const [pdfData, setPdfData] = useState(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [shouldNavigate, setShouldNavigate] = useState(false);
  const [severity, setSeverity] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const contentBottomRef = useRef(null);
  const success = tiReducer?.successMessage;
  const error = tiReducer?.error;
  const errore = tiReducer?.errore;
  const facturePDF = tiReducer?.factureDocumentPdf;
  const documentPdf = tiReducer?.documentPdf;
  const isDownloadLoading = tiReducer?.isDownloadLoading;
  const createBlobUrl = (base64) => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {
      type: "application/pdf",
    });
    return URL.createObjectURL(blob);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    setOpenFacture(false);
    setPdfData(null);
    dispatch(getTi(id, "CONSULTER"));
  }, []);

  const handleCloseFacture = () => {
    setOpenFacture(false);
    setPdfData(null);
  };

  const handleCloseDoc = () => {
    setOpenDoc(false);
    setPdfData(null);
  };

  useEffect(() => {
    if (facturePDF !== null && facturePDF !== "") {
      setPdfData(facturePDF);
      setOpenFacture(true);
    }
  }, [facturePDF]);

  useEffect(() => {
    if (documentPdf !== null && documentPdf !== "") {
      setPdfData(documentPdf);
      setOpenDoc(true);
    }
  }, [documentPdf]);

  useEffect(() => {
    if (success !== null) {
      setAlertMessage(success);
      setShouldNavigate(true);
      setAlertOpen(true);
      setSeverity("success");
    } else if (error !== null) {
      setAlertMessage(
        error?.message
          ? error?.message
          : "Une erreur s'est produite, merci de ressayer plus tard"
      );
      setShouldNavigate(false);
      setAlertOpen(true);
      setSeverity("error");
    } else if (errore !== null) {
      setAlertMessage(errore);
      setAlertOpen(true);
      setSeverity("error");
    }
  }, [success, error, errore]);

  const handlePrintClick = () => {
    dispatch(downloadTi(id));
  };

  const handleHistoriqueClick = () => {
    navigate(TITRE_HISTORIQUE_PAGE + id);
  };

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    if (shouldNavigate === true) {
      if (isModeConsultation) {
        navigate(CONSULTATION_TITRES_PAGE);
      } else {
        navigate(GESTION_TITRES_PAGE);
      }
    }
    dispatch(clearTiErrors());
    setAlertOpen(false);
  };

  return (
    <Box>
      <Helmet>
        <title>{"Détails titre - Portail Banques"}</title>
      </Helmet>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box>
          <Modal
            open={isDownloadLoading}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255, 255, 255, 0.1)",
            }}
          >
            <CircularProgress />
          </Modal>
          <Modal open={openFacture} onClose={handleCloseFacture}>
            <Box
              style={{
                position: "absolute",
                top: "10%",
                left: "10%",
                right: "10%",
                bottom: "10%",
                backgroundColor: "white",
                padding: 20,
                overflow: "scroll",
              }}
            >
              {pdfData !== null && (
                <iframe
                  src={createBlobUrl(pdfData)}
                  style={{ width: "100%", height: "100%" }}
                  title="pdf"
                ></iframe>
              )}
            </Box>
          </Modal>
          <Modal open={openDoc} onClose={handleCloseDoc}>
            <Box
              style={{
                position: "absolute",
                top: "10%",
                left: "10%",
                right: "10%",
                bottom: "10%",
                backgroundColor: "white",
                padding: 20,
                overflow: "scroll",
              }}
            >
              {pdfData !== null && (
                <iframe
                  src={createBlobUrl(pdfData)}
                  style={{ width: "100%", height: "100%" }}
                  title="pdf"
                ></iframe>
              )}
            </Box>
          </Modal>
          <StickyCustomized>
            {!Boolean(props.isDecisionDomiciliation) && (
              <Box>
                <PaperCustomized forActions={true}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      paddingRight: 1,
                    }}
                  >
                    <Box>
                      <ButtonCustomized
                        onClick={() => {
                          if (isModeConsultation) {
                            navigate(CONSULTATION_TITRES_PAGE);
                          } else {
                            navigate(GESTION_TITRES_PAGE);
                          }
                        }}
                        title="Retour"
                        startIcon={<ArrowBackIosIcon />}
                      />
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        paddingRight: 1,
                        gap: 1,
                      }}
                    >
                      <Box>
                        <ButtonCustomized
                          title="Historique"
                          startIcon={<HistoryIcon />}
                          onClick={handleHistoriqueClick}
                        />
                      </Box>
                      <Box>
                        <ButtonCustomized
                          title="Imprimer"
                          startIcon={<LocalPrintshopIcon />}
                          onClick={handlePrintClick}
                        />
                      </Box>
                    </Box>
                  </Box>
                </PaperCustomized>
              </Box>
            )}
          </StickyCustomized>
          {tiDetail?.transitaire && (
            <Box sx={{ marginTop: "40px" }}>
              <PaperCustomized forActions={false} title="Declarant">
                <Box>
                  <Grid container spacing={1}>
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="Description"
                        value={tiDetail?.transitaire?.description}
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="Centre RC"
                        value={tiDetail?.transitaire?.centreRc}
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="IFU"
                        value={tiDetail?.transitaire?.ifu}
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="Numero RC"
                        value={tiDetail?.transitaire?.numRc}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </PaperCustomized>
            </Box>
          )}

          <Box sx={{ marginTop: "40px" }}>
            <PaperCustomized forActions={false} title="Importateur">
              <Box>
                <Grid container spacing={1}>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Description"
                      value={
                        tiDetail?.operateurImportateurExportateur?.description
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="code PIN"
                      value={tiDetail?.operateurImportateurExportateur?.codePIN}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Centre RC"
                      value={
                        tiDetail?.operateurImportateurExportateur?.centreRc
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Tax Professionnelle"
                      value={
                        tiDetail?.operateurImportateurExportateur?.tasaSocial
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="IFU"
                      value={tiDetail?.operateurImportateurExportateur?.ifu}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Numero RC"
                      value={
                        tiDetail?.operateurImportateurExportateur?.numeroRc
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Nº fichier DCE"
                      value={
                        tiDetail?.operateurImportateurExportateur?.numFicheroDCE
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Courrier électronique"
                      value={tiDetail?.operateurImportateurExportateur?.email}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Code postal"
                      value={tiDetail?.operateurImportateurExportateur?.email}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Tèl mobile"
                      value={
                        tiDetail?.operateurImportateurExportateur?.telMobile
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Tèl fixe"
                      value={tiDetail?.operateurImportateurExportateur?.telFixe}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Adresse"
                      value={
                        tiDetail?.operateurImportateurExportateur?.adresse2
                      }
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Localité"
                      value={
                        tiDetail?.operateurImportateurExportateur?.ville
                          ?.description
                      }
                    />
                  </Grid>
                </Grid>
              </Box>
            </PaperCustomized>
          </Box>
          <Box sx={{ marginTop: "40px" }}>
            <PaperCustomized
              forActions={false}
              title="Données du Titre d'Importation"
            >
              <Box>
                <Grid container spacing={1}>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="N° d'enregistrement"
                      value={tiDetail?.numEnregistrement}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Catégorie du titre"
                      value={tiDetail?.typeTitreImportation?.description}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Etat"
                      value={tiDetail?.typeEtatTitreImportation?.description}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="modalités paiement"
                      value={tiDetail?.modalitePaiement?.description}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Devise"
                      value={tiDetail?.typeDevise?.code}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Montant total"
                      value={tiDetail?.montantTotal}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Condition livraison"
                      value={tiDetail?.conditionLivraison?.description}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Régime douanier"
                      value={tiDetail?.regimeDouanier?.description}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Bureau douanier"
                      value={tiDetail?.bureauDouanier?.description}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <BoldTypography
                      label="Expediteur"
                      value={tiDetail?.expiditeur}
                    />
                  </Grid>
                </Grid>
              </Box>
            </PaperCustomized>
          </Box>
          {tiDomiciliationBanque && (
            <Box sx={{ marginTop: "40px" }}>
              <PaperCustomized
                forActions={false}
                title="Données relatives à la domiciliation"
              >
                <Box>
                  <Grid container spacing={1}>
                    {tiDomiciliationBanque?.numTitreImportation ? (
                      <Grid item md={4} xs={12}>
                        <BoldTypography
                          label="Nº de domiciliation"
                          value={tiDomiciliationBanque?.numTitreImportation}
                        />
                      </Grid>
                    ) : null}
                    {tiDomiciliationBanque?.numTitreImportation ? (
                      <Grid item md={4} xs={12}>
                        <BoldTypography
                          label="Date d'acceptation"
                          value={formattedDateFromDB(
                            tiDomiciliationBanque?.dateDomiciliation
                          )}
                        />
                      </Grid>
                    ) : null}
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="Montant Total"
                        value={tiDetail?.montantTotal}
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="Montant FOB"
                        value={tiDomiciliationBanque?.quantiteFOB}
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="Assurance"
                        value={tiDomiciliationBanque?.assurance}
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="Montant FRET"
                        value={tiDomiciliationBanque?.quantiteCharge}
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="Accessoires"
                        value={tiDomiciliationBanque?.activites}
                      />
                    </Grid>
                    {tiDomiciliationBanque?.numTitreImportation ? (
                      <Grid item md={4} xs={12}>
                        <BoldTypography
                          label="Date début de validité"
                          value={formattedDateTimeFromDB(
                            tiDomiciliationBanque?.dateDebutValiditee
                          )}
                        />
                      </Grid>
                    ) : null}
                    {tiDomiciliationBanque?.numTitreImportation ? (
                      <Grid item md={4} xs={12}>
                        <BoldTypography
                          label="Date fin de validité"
                          value={formattedDateTimeFromDB(
                            tiDomiciliationBanque?.dateFinValiditee
                          )}
                        />
                      </Grid>
                    ) : null}
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="RIB"
                        value={tiDomiciliationBanque?.tiCompteBanque?.numCompte}
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="Guichet"
                        value={
                          tiDomiciliationBanque?.tiCompteBanque?.agenceBanque
                            ?.code
                        }
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="Banque"
                        value={
                          tiDomiciliationBanque?.tiCompteBanque?.agenceBanque
                            ?.banque?.description
                        }
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <BoldTypography
                        label="Code"
                        value={
                          tiDomiciliationBanque?.tiCompteBanque?.agenceBanque
                            ?.banque?.code
                        }
                      />
                    </Grid>
                  </Grid>
                </Box>
              </PaperCustomized>
            </Box>
          )}
          {tiDetail?.paysTitreImportation?.length !== 0 && (
            <Box sx={{ marginTop: "40px" }}>
              <ListPaysProvenances detail={tiDetail} />
            </Box>
          )}
          {tiDetail?.arrTiFacturas?.length !== 0 && (
            <Box sx={{ marginTop: "40px" }}>
              <ListFactures
                detail={tiDetail}
                etat={tiDetail?.typeEtatTitreImportation?.description}
              />
            </Box>
          )}
          {tiDetail?.document?.length !== 0 && (
            <Box sx={{ marginTop: "40px" }}>
              <ListDocuments detail={tiDetail} />
            </Box>
          )}
          {tiDetail?.modificacionMercancias && (
            <Box sx={{ marginTop: "40px" }}>
              <ListMarchandisesModified detail={tiDetail} />
            </Box>
          )}
          {tiDetail?.arrTiMercancia?.length !== 0 && (
            <Box sx={{ marginTop: "40px" }}>
              <ListMarchandises
                detail={tiDetail}
                modified={tiDetail?.modificacionMercancias}
              />
            </Box>
          )}
          {tiDetail?.marchandisesImputes?.length !== 0 && (
            <Box sx={{ marginTop: "40px" }}>
              <ListMarchandisesImputees detail={tiDetail} />
            </Box>
          )}

          {tiDetail?.tracabiliteMinistere?.length !== 0 && (
            <Box sx={{ marginTop: "40px" }}>
              <ListTracMinistere detail={tiDetail} />
            </Box>
          )}
          {tiDetail?.donneeReglamentationDtos &&
          tiDetail?.donneeReglamentationDtos.length > 0 ? (
            <Box sx={{ marginTop: "40px" }}>
              <ListReglamentation detail={tiDetail} />
            </Box>
          ) : null}

          <Box sx={{ marginTop: "40px" }}>
            <PaperCustomized title={"Observations"} forActions={false}>
              <BoldTypography
                label="Observations "
                value={tiDetail.observations}
              />
            </PaperCustomized>
          </Box>
        </Box>
      )}
      <Box>
        <Snackbar
          open={alertOpen}
          autoHideDuration={2000}
          onClose={handleSnackClose}
        >
          <Alert
            onClose={handleSnackClose}
            severity={severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {alertMessage}
          </Alert>
        </Snackbar>
      </Box>
      <div ref={contentBottomRef}></div>
      <ScrollToTop />
    </Box>
  );
}

export default TitreDetailConsult;
